import { render, staticRenderFns } from "./ServiceAdditional.vue?vue&type=template&id=640fc472&"
import script from "./ServiceAdditional.vue?vue&type=script&lang=js&"
export * from "./ServiceAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports